const tours = {
  availableEscapes: "Escapes disponíveis", // translated
  addOns: "Complementos", // translated
  sendRequest: "Enviar pedido", // translated
  availableExperiences: "Experiências disponíveis", // translated
  tours: "Passeios", // translated
  selectRoom: "Selecione um quarto", // translated
  tour: "Percorrer", // translated
  getRequest: "Obter solicitação", // translated
  addOn: "Adicionar", // translated
};


export default tours;
